export const OVERVIEW_DATEPICKER_FORMATS = {
    parse: {
        dateInput: 'DD.MM.YYYY',
    },
    display: {
        dateInput: 'DD.MM.YYYY',
        monthYearLabel: 'MMM YYYY',
        dateA11yLabel: 'LL',
        monthYearA11yLabel: 'MMMM YYYY',
    },
};

export const localDateFormat = "DD.MM.YYYY";
export const serverDateFormat = "DD.MM.YYYY";